import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';

const styles = css`
  &.copy-button {
    background: transparent;
    border: none;
    color: ${COLORS.NEUTRAL400};
    cursor: pointer;
    margin-left: 4px;
    padding: 2px 4px;
    opacity: 0;
    transition: opacity 0.15s ease, color 0.15s ease;
  }

  /* Show on hover of the parent cell so the icon doesn't clutter the table. */
  *:hover > &.copy-button,
  &.copy-button:hover,
  &.copy-button:focus-visible {
    opacity: 1;
    color: ${COLORS.NEUTRAL700};
  }

  /* Label mode (e.g. "Copy row") — the button is a primary action, not a
     hover affordance. Always visible, with a small gap between icon and label. */
  &.copy-button--with-label {
    opacity: 1;
    color: ${COLORS.NEUTRAL700};
  }

  &.copy-button--with-label .copy-button__label {
    margin-left: 4px;
  }
`;

export default styles;
